<template>
  <div id="appContent">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    <audio :src="audioSrc" ref="examAudio" @error="audioError"></audio>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  pageShowToConnect,
  pageHiddenToGetWSUrl,
  closeWS,
} from "./utils/lessonws";
import axios from "axios";
import qs from "qs";
export default {
  name: "App",
  components: {
    // MaskComp
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      // 获取隐私政策是否已经执行过
      privacyModal: false,
      // 当前展示的第几个公告
      nowPrivacyIndex: 0,
      // 所有公告
      allPrivacyArray: [],
      // 查询音频准备时长
      timerNum: 0,
      // websocket的url
      wsUrl: null,
      //   showbigmask: 0,
      //   modalTip: '您已在其他地方登录，当前帐号已经退出。如果这不是你本人的操作，请注意安全。'
    };
  },
  computed: {
    ...mapState({
      // 在线课程和接口学课小测验音频数据
      setPalyer: (state) => state.examAudio.autoPalyer,
      audioState: (state) => state.examAudio.audioState,
      audioSrc: (state) => state.examAudio.audioSrc,
      quiz_match: (state) => state.examAudio.quiz_match,
    }),
  },
  mounted() {
    // alert('app:'+window.location.href)
    console.log(
      "代码更新了1208-v1",
      localStorage.getItem("_user_data_sso_token")
    );
    // console.log("解绑2",'先到app页面还是到login页面——app',decodeURI(window.location.href))
    // console.log(this.$route.path)
    if (
      window.location.href.indexOf("/weixinLogin") === -1 &&
      window.location.href.indexOf("/weixinLoginTpi") === -1
    ) {
      if (
        navigator.userAgent.toLowerCase().match(/wxwork/i) == "wxwork" &&
        !localStorage._user_data_sso_token
      ) {
        localStorage.setItem("toWeixinMiddle", 1);
        // 直接跳转到中间页
        this.$router.push({
          name: "weixinMiddle",
          query: {
            fromUrl: encodeURIComponent(window.location.href),
          },
        });
        return;
      }
    }

    if (this.$route.name === "Index" || this.$route.name === "livingDetail") {
      if (this.privacyModal === false) {
        this.getPrivacy();
      }
    } else if (
      this.$route.name === "Login" ||
      this.$route.name === "365SMSentry" ||
      this.$route.name === "dingtalkLogin" ||
      this.$route.name === "weixinLogin"
    ) {
      this.privacyModal = false;
    }

    // 监听播放器状态
    this.watchMusicState();
    this.$refs.examAudio.load();
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        // 页面被挂起
        this.$refs.examAudio.pause();
        this.setAutoPlayer(false);
        this.wsUrl = pageHiddenToGetWSUrl();
        closeWS();
      } else {
        if (this.wsUrl && this.wsUrl.length > 0) {
          pageShowToConnect(this.wsUrl);
          this.wsUrl = null;
        }
      }
    });

    // // ws计时提示弹窗组件
    // this.$EventBus.$on('modalTip', (modalTip) => {
    //   this.showbigmask = 1
    //   this.modalTip = modalTip
    // })
  },
  methods: {
    ...mapMutations("examAudio", ["setAudioState", "setAutoPlayer"]),

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    // // 判断是企业微信/企业微信代开发
    // isQYWXTPI() {
    //   let url = "index.php/mobile/qywx/qywx-is-custom-app"
    //   const companyCode = location.origin.split(".")[0].split("//")[1];
    //   let params = {
    //     company_code: process.env.VUE_APP_MODE === "local" ? "intest" : companyCode,
    //   };
    //   axios({
    //     url: url,
    //     method: "post",
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     data: qs.stringify(params),
    //   }).then(function (res) {
    //     console.log('判断是企业微信/企业微信代开发1是代开发0否', res.data.result.is_custom_app)
    //     if(res.data.code==0){
    //       localStorage.setItem("is_custom_app", res.data.result.is_custom_app);
    //     }
    //   })
    // },
    // 获取公告或隐私政策
    getPrivacy() {
      axios
        .post(
          `index.php/mobile/notice/list-unread`,
          qs.stringify({
            user_id: localStorage._user_data_id,
            company_id: localStorage._user_data_company_id,
            department_id: localStorage._user_data_department_id,
            language: localStorage._user_data_language,
            sso_token: localStorage._user_data_sso_token,
            sys_id: "5",
          })
        )
        .then((res) => {
          if (res.data.code === 0) {
            this.privacyModal = true;
            this.allPrivacyArray = res.data.result.list
              ? res.data.result.list
              : [];
            if (this.allPrivacyArray.length > 0) {
              this.$pivacypolicy({
                title: this.allPrivacyArray[this.nowPrivacyIndex].title,
                content: this.allPrivacyArray[this.nowPrivacyIndex].content,
                button:
                  this.allPrivacyArray[this.nowPrivacyIndex].buttons[0].title,
                callback: this.fadeInPrivacy,
              });
            }
          }
        });
    },
    // 显示公告
    fadeInPrivacy() {
      this.readPrivacy();
      setTimeout(() => {
        this.nowPrivacyIndex = this.nowPrivacyIndex + 1;
        if (this.nowPrivacyIndex < this.allPrivacyArray.length) {
          this.$pivacypolicy({
            title: this.allPrivacyArray[this.nowPrivacyIndex].title,
            content: this.allPrivacyArray[this.nowPrivacyIndex].content,
            button: this.allPrivacyArray[this.nowPrivacyIndex].buttons[0].title,
            callback: this.fadeInPrivacy,
          });
        }
      }, 2000);
    },
    // 确定已读隐私公告
    readPrivacy() {
      axios
        .post(
          `index.php/mobile/notice/read`,
          qs.stringify({
            user_id: localStorage._user_data_id,
            company_id: localStorage._user_data_company_id,
            department_id: localStorage._user_data_department_id,
            language: localStorage._user_data_language,
            sso_token: localStorage._user_data_sso_token,
            sys_id: "5",
            id: this.allPrivacyArray[this.nowPrivacyIndex].id,
          })
        )
        .then();
    },

    // 播放出错
    audioError() {
      if (this.audioSrc) {
        this.$toast("音频加载出错了");
        let $audio = this.$refs.examAudio;
        $audio.pause();
      }
    },
    // 开始播放
    startPlayAudio() {
      let $audio = this.$refs.examAudio; // 获取音乐DOM节点
      $audio.currentTime = 0;
      $audio.load();
      this.watchReadySatet();
    },
    // 轮询音频加载状态
    watchReadySatet() {
      let $audio = this.$refs.examAudio;
      if ($audio.readyState || this.timerNum > 3) {
        $audio.play();
        this.timerNum = 0;
        if ($audio.paused) {
          this.setAutoPlayer(false);
          this.$toast("自动播放被拦截，请手动播放配音");
        }
      } else {
        setTimeout(() => {
          this.timerNum = this.timerNum + 1;
          this.watchReadySatet();
        }, 500);
      }
    },
    // 关闭播放音频
    closeAudio() {
      let $audio = this.$refs.examAudio; // 获取音乐DOM节点
      this.$nextTick(() => {
        if (!$audio.paused) {
          $audio.pause();
        }
      });
    },
    // 开始播放音频
    audioSatrt() {
      let $audio = this.$refs.examAudio; // 获取音乐DOM节点
      this.$nextTick(() => {
        if ($audio.paused) {
          $audio.play();
        }
      });
    },
    // 监听音乐播放状态：改变播放或暂停按钮
    watchMusicState() {
      let $audio = this.$refs.examAudio; // 获取音乐DOM节点
      $audio.addEventListener("playing", () => {
        // 播放状态Doing
        this.setAudioState("playing");
      });
      $audio.addEventListener("pause", () => {
        // 暂停状态Doing
        this.setAudioState("pause");
      });
      $audio.addEventListener("ended", () => {
        // 暂停状态Doing
        this.setAudioState("ended");
        this.setAutoPlayer(false);
      });
    },
  },
  watch: {
    $route(to) {
      if (to.name === "Index" || to.name === "livingDetail") {
        if (this.privacyModal === false) {
          this.getPrivacy();
        }
      } else if (to.name === "Login") {
        this.privacyModal = false;
      }

      if (window.location.href.indexOf("/appMiddle") !== -1) {
        return;
      }
      // 当天第一次登录时，调用登录接口
      if (
        localStorage.getItem("date") != null &&
        localStorage._user_data_sso_token &&
        localStorage._user_data_id &&
        localStorage._username
      ) {
        if (localStorage.getItem("date") != new Date().toLocaleDateString()) {
          localStorage.setItem("date", new Date().toLocaleDateString());
          let url = "index.php/mobile/user-info/add-login-inter";
          let params = {
            user_id: localStorage._user_data_id,
            company_id: localStorage._user_data_company_id,
            department_id: localStorage._user_data_department_id,
            language: localStorage._user_data_language,
            sso_token: localStorage._user_data_sso_token,
            sys_id: "5",
            // 打包代码
            company_code: window.location.origin.split(".")[0].split("//")[1],
          };
          axios.post(url, qs.stringify(params)).then();
        }
      }
    },
    // 设置音频播放
    setPalyer(newVal) {
      if (newVal && this.audioState == "ended") {
        this.startPlayAudio();
      } else if (newVal) {
        this.audioSatrt();
      } else {
        this.closeAudio();
      }
    },
  },
};
</script>

<style>
#appContent {
  width: 100%;
  height: 100%;
  touch-action: pan-y;
}
</style>
